import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ITeste } from 'src/app/shared/api/testes/testes.service';
import { EditComponentComponent } from 'src/app/shared/components/edit-component/edit-component.component';
import { ModulosComponent } from '../../modulos/modulos.component';

@Component({
    selector: 'app-teste-form',
    templateUrl: './teste-form.component.html',
    styleUrls: ['./teste-form.component.css']
})
export class TesteFormComponent implements OnInit {
    @ViewChild('formTeste') formTeste!: EditComponentComponent;
    @ViewChild('modulosComponent') modulosComponent!: ModulosComponent;

    id: any;
    teste!: ITeste;

    constructor(
        private route: ActivatedRoute
    ) {}

    ngOnInit(): void {
        this.id = this.route.snapshot.paramMap.get('id');
    }

    changeVersao(){
        this.modulosComponent.listarModulos();
    }

    setEntidade(teste: ITeste){
        this.teste = teste;
    }
    
}
